/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UserType = {
    GOD_ADMIN: 'GOD_ADMIN',
    STANDARD_ADMIN: 'STANDARD_ADMIN',
    MERCHANT: 'MERCHANT',
    SUPPORT_AGENT: 'SUPPORT_AGENT',
    PARTNER: 'PARTNER',
    STANDARD_USER: 'STANDARD_USER',
    HUB_OWNER: 'HUB_OWNER'
} as const;
export type UserType = typeof UserType[keyof typeof UserType];


export function instanceOfUserType(value: any): boolean {
    for (const key in UserType) {
        if (Object.prototype.hasOwnProperty.call(UserType, key)) {
            if (UserType[key as keyof typeof UserType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserTypeFromJSON(json: any): UserType {
    return UserTypeFromJSONTyped(json, false);
}

export function UserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserType {
    return json as UserType;
}

export function UserTypeToJSON(value?: UserType | null): any {
    return value as any;
}

export function UserTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): UserType {
    return value as UserType;
}

